const Spreadit = () => {
    return (
        <div>
            <p>
                This is a project made for the Information Systems class.
                Unfortunately the repository is private and I'm not the owner, so
                the code is not available.
                <br />
                We created a webapp using <code>C#</code> and <code>.NET 6</code>. I learned
                how the MVC (Model-View-Controller) works, how to set up a database in such
                environment and connect to it through the backend. I also learned how to properly
                store information about users (mainly passwords), authenticate and authorize them, and implement
                CRUD functionality.
                <br />
                Lastly, we created an Android app which uses the same backend API, so functionality stays the same,
                only the view changes.
                <br />
                We were both very happy with the result, since we created a fully functional web (and mobile) application.
            </p>
        </div>
    )
}

export default Spreadit;